import timetable from "./instruments/timetable";
import exchange from "./instruments/exchange";
import settings from "./instruments/settings";
import reports from "./instruments/reports";
import forecast from "./instruments/forecast";
import staff from "./instruments/staff";
import { EMPLOYEE_EMPLOYMENT_STATUSES, NETWORK_EMPLOYMENT_STATUSES, INTERNAL_EMPLOYMENT_STATUSES, OUTSOURCE_EMPLOYMENT_STATUSES } from '@/config/time-table';
export default {
  locales: {
    selectTitle: 'Select language'
  },
  modal: {
    ok: 'Ok',
    cancel: 'Cancel',
    delete: 'Delete',
    copy: 'Copy',
    filter: 'Apply filter'
  },
  mainTerms: {
    hour: 'h',
    preliminaryCostPerHour: 'Preliminary cost of an hour',
    preliminaryCostPerHourMoney: 'r/hour',
    tabelCode: 'tabel code',
    TabelCode: 'Tabel code',
    tabCode: 'tab. code',
    outsource: 'outsource',
    department: 'Department',
    selected: 'Selected',
    save: 'Save',
    download: 'Download',
    noResults: 'Not results',
    position: 'position',
    workType: 'work type',
    dayType: 'day type',
    tabelType: 'tabel type',
    error: 'Error',
    lastName: 'Last Name',
    firstName: 'First Name',
    middleName: 'Middle Name',
    worker: 'Worker',
    day: 'day',
    date: 'date',
    minutes: 'min',
    sex: [{
      label: 'Female',
      value: 'F'
    }, {
      label: 'Male',
      value: 'M'
    }],
    sexLabel: 'Sex',
    phone: 'Phone number',
    yesNo: {
      yes: 'Yes',
      no: 'No'
    },
    confirmationTitle: 'Confirmation',
    // status: {
    //   'W': 'Working day',
    //   'H': 'Day off',
    //   'V': 'Vacation',
    //   'TV': 'Vacation at your own expense',
    //   'Q': 'Studying',
    //   'A': 'Absence',
    //   'M': 'Maternity leave',
    //   'S': 'Sick leave',
    //   'T': 'Business trip',
    //   'O': 'Other',
    //   'E': 'Deleting',
    //   'D': 'Empty'
    // },
    // statusShort: {
    //   'W': 'W/D',
    //   'H': 'DOff',
    //   'V': 'Vac',
    //   'TV': 'VacOwn',
    //   'Q': 'St',
    //   'A': 'Abs',
    //   'M': 'Mat',
    //   'S': 'SickL',
    //   'T': 'BT',
    //   'O': 'Oth',
    //   'E': 'Del',
    //   'D': 'Emp'
    // },
    from: 'from',
    to: 'to',
    noData: 'No data',
    plan: 'Plan',
    fact: 'Fact',
    clear: 'Clear',
    of: 'of',
    details: 'Details',
    apply: 'Apply',
    delete: 'Delete',
    add: 'Add',
    rus: 'рус',
    eng: 'eng',
    selectEmployee: 'Select employee',
    resetButton: 'Reset',
    allWorkTypes: 'All work types',
    additionalShifts: 'Opened shifts',
    info: 'General information',
    login: 'Login',
    security: 'Security',
    changePassword: 'Change user password',
    confirmationPasswordInput: 'password for confirmation',
    confirmationPasswordLabel: 'Enter your password to confirm',
    userPasswordInput: 'new employee password',
    userPasswordLabel: 'Enter new employee password',
    outsourcingCompany: 'Outsourcing company',
    outsourcingCompanies: 'Outsourcing companies',
    nothingFound: 'Nothing found',
    biometric: 'Biometric',
    deleteBiometric: 'Delete biometric',
    addBiometric: 'Add biometric',
    name: 'Name',
    code: 'Code',
    depNotSelected: 'Department not selected',
    savedSuccessfully: 'Saved successfully',
    failedToSave: 'Error. No data has been saved.'
  },
  layouts: {
    login: {
      loginLabel: 'Login',
      passwordLabel: 'Password',
      submitLabel: 'Log in',
      badLogin: 'Too short login',
      badPassword: 'Too short password',
      topLabel1: 'Let\'s make the company better together',
      authFailed: 'Wrong login or/and password',
      resetPassword: 'Reset password',
      backToAuth: 'Back to login page',
      forgotPassword: 'Forgot password'
    },
    main: {
      exitMenuItem: {
        title: 'Exit',
        icon: 'exit_to_app'
      },
      profile: {
        changePassword: 'Change password',
        exit: 'Exit',
        reference: 'Reference',
        version: 'Version',
        buildDate: 'Build date',
        noAppInfo: 'No application data'
      }
    }
  },
  menu: [
  /*
  {
    path: '/schedule',
    title: 'My schedule'
  },
  */
  {
    path: '/forecast',
    allowedTab: 'load_forecast',
    title: 'Demand forecast',
    metrikaIdReach: 'follow_to_header_forecast'
  }, {
    path: '/timetable',
    allowedTab: 'schedule',
    title: 'Timetable',
    metrikaIdReach: 'follow_to_header_timetable'
  }, {
    path: '/staff',
    allowedTab: 'employees',
    title: 'Staff',
    metrikaIdReach: 'follow_to_header_staff'
  }, {
    path: '/exchange',
    allowedTab: 'shift_exchange',
    title: 'Shift exchange',
    metrikaIdReach: 'follow_to_header_exchange'
  }, {
    path: '/reports',
    allowedTab: 'analytics',
    title: 'Analytics',
    metrikaIdReach: 'follow_to_header_reports'
  }, {
    allowedTab: 'settings',
    path: '/settings',
    title: 'Settings'
  }],
  instruments: {
    staticInstruments: {
      dateRange: {
        from: 'from',
        to: 'to'
      },
      departmentLabel: 'Store'
    },
    confirmationGraph: [{
      value: 'acceptPlanned',
      label: 'planned'
    }, {
      value: 'acceptFactual',
      label: 'factual'
    }],
    timetable: timetable,
    exchange: exchange,
    staff: staff,
    forecast: forecast,
    schedule: [],
    reports: reports,
    settings: settings
  },
  pages: {
    timetable: {
      dayCellSaved: 'Working day data changed successfully',
      dailyStatsTypes: [{
        label: 'Covering',
        value: 'covering'
      }, {
        label: 'Dead time',
        value: 'deadtime'
      }, {
        label: 'Working hours by load',
        value: 'predict_hours'
      }, {
        label: 'Hours without open vacancies (excluding breaks)',
        value: 'graph_hours'
      }, {
        label: 'Hours with open vacancies (excluding breaks)',
        value: 'graph_hours_with_open_vacancies'
      }, {
        label: 'Hours with breaks (without open vacancies)',
        value: 'work_hours'
      }, {
        label: 'Number of working people (without open vacancies)',
        value: 'work_days'
      }, {
        label: 'Turnover (income)',
        value: 'income'
      }, {
        label: 'Productivity (turnover / hours with breaks)',
        value: 'perfomance'
      }
      /*
      { label: 'Смен всего', value: 'shop_shifts' },
      { label: 'Рабочих часов', value: 'shop_paid_hours' },
      { label: 'Открытых смен', value: 'vacancies_shifts' },
      { label: 'Работников из других <%shop_plural_R%>', value: 'outsource_shifts' },
      { label: 'ФОТ', value: 'shop_fot' }
      */
      ],
      byWorkTypes: 'by work types',
      byOperationTypes: 'by operation types',
      workerSortTypes: [{
        label: 'Position',
        type: 'position'
      }, {
        label: 'Full Name A-Z',
        type: 'fullname-0-1'
      }, {
        label: 'Number of working days',
        type: 'workingDaysAmount'
      }, {
        label: 'Number of days off',
        type: 'holidaysAmount'
      }],
      statsLeft: {
        top: [{
          label: 'Working days in the current store',
          value: 'work_days_selected_shop'
        }, {
          label: 'Working days in other stores',
          value: 'work_days_other_shops'
        }, {
          label: 'Working days in all stores',
          value: 'work_days_total'
        }, {
          label: 'Working hours in other stores',
          value: 'work_hours_other_shops'
        }, {
          label: 'Working hours in the current store',
          value: 'work_hours_selected_shop'
        }, {
          label: 'Working hours in all stores',
          value: 'work_hours_total'
        }, {
          label: 'Working hours in all stores (main)',
          value: 'work_hours_all_shops_main'
        }, {
          label: 'Working hours in all stores (additional)',
          value: 'work_hours_all_shops_additional'
        }, {
          label: 'Working hours for the accounting period',
          value: 'work_hours_acc_period'
        }, {
          label: 'The rate of hours for the current month (recommended)',
          value: 'sawh_hours_curr_month'
        }, {
          label: 'The rate of hours for the current month (rec. without reduce)',
          value: 'sawh_hours_curr_month_without_reduce_norm'
        }, {
          label: 'Clock rate for the current month (prod. cal.)',
          value: 'norm_hours_curr_month'
        }, {
          label: 'Hours norm at the end of the current month (prod. cal.)',
          value: 'norm_hours_curr_month_end'
        }, {
          label: 'The rate of hours for the accounting period (prod. cal.)',
          value: 'norm_hours_acc_period'
        }, {
          label: 'Overtime for the current month (prod. cal.)',
          value: 'overtime_curr_month'
        }, {
          label: 'Processing at the end of the current month (prod. cal.)',
          value: 'overtime_curr_month_end'
        }, {
          label: 'Recycling in the past months (prod. cal.)',
          value: 'overtime_prev_months'
        }, {
          label: 'Processing over the reference period (prod. cal.)',
          value: 'overtime_acc_period'
        } // { label: 'Working day', value: 'day_type_W' },
        // { label: 'Day off', value: 'day_type_H' },
        // { label: 'Vacation', value: 'day_type_V' },
        // { label: 'Vacation at your own expense', value: 'day_type_TV' },
        // { label: 'Studying', value: 'day_type_Q' },
        // { label: 'Maternity leave', value: 'day_type_М' },
        // { label: 'Sick leave', value: 'day_type_S' },
        // { label: 'Business trip', value: 'day_type_T' },
        // { label: 'Absence', value: 'day_type_A' },
        // { label: 'Other', value: 'day_type_O' }
        ]
      },
      timesheetStats: [{
        label: 'All hours of actual timesheet',
        value: 'fact_total_all_hours_sum'
      }, {
        label: 'Work hours of actual timesheet',
        value: 'fact_total_work_hours_sum'
      }, {
        label: 'Work hours of main timesheet (all)',
        value: 'main_total_hours_sum'
      }, {
        label: 'Work hours of main timesheet (night)',
        value: 'main_night_hours_sum'
      }, {
        label: 'Work hours of additional timesheet',
        value: 'additional_hours_sum'
      }, {
        label: 'Recommended rate of hours',
        value: 'sawh_hours'
      }, {
        label: 'Recommended rate of hours (without reduce)',
        value: 'sawh_hours_without_reduce'
      }, {
        label: 'Hours per prod. calendar',
        value: 'norm_hours'
      }],
      workerDayLabelByArg: {
        'PLAN_APPR': 'plan appr.',
        'PLAN_UNAPPR': 'plan draft',
        'FACT_APPR': 'fact appr.',
        'FACT_UNAPPR': 'fact draft'
      },
      autoSchedulingModal: {
        title: 'Scheduling',
        period: 'Compilation period',
        changesSettings: [{
          label: 'Without changing existing shifts',
          value: false
        }, {
          label: 'With the change of existing shifts',
          value: true
        }
        /* { label: 'С изменением существующих смен, кроме заказных', value: 3 } */
        ],
        useNotApproved: 'Use not approved version',
        deleteManualChanges: 'Remove manual changes',
        deleteNotApprovedTimetable: 'Remove not approved schedule',
        deleteTimetableOk: 'Request to delete a schedule has been sent successfully',
        deleteTimetableError: 'An error occurred while sending a request to delete a schedule',
        autoschedulingStartError: 'An error occured while submitting an auto-scheduling request',
        autoschedulingStartOk: 'Autoscheduling started successfully',
        intendFor: 'intend for',
        ok: 'Start',
        status: {
          'P': 'The schedule is drawn up'
        },
        searchWorkers: 'Search'
      },
      fullWorkerDayEditorModal: {
        title: 'Working day management',
        titleVacancy: 'Vacancy management',
        titleVacancyNew: 'Creating a new vacancy',
        timeBegin: 'start time',
        timeEnd: 'end time',
        comment: 'comment',
        ok: 'Save changes',
        removeShift: 'Remove shift',
        deleteModal: {
          question: 'Are you sure you want to remove the vacancy?',
          answerPositive: 'Vacancy removed successfully',
          answerNegative: 'Failed to remove vacancy'
        },
        workerEmploymentStatus: [{
          label: 'Employee',
          value: EMPLOYEE_EMPLOYMENT_STATUSES
        }, {
          label: 'Network',
          value: NETWORK_EMPLOYMENT_STATUSES
        }, {
          label: 'Internal',
          value: INTERNAL_EMPLOYMENT_STATUSES
        }, {
          label: 'Outsource',
          value: OUTSOURCE_EMPLOYMENT_STATUSES
        }],
        selectCategory: 'Select category',
        selectEmployee: 'Select employee',
        selectOutsourcing: 'Select outsourcing company',
        enterTheDate: 'enter the date',
        enterTheData: 'enter your last name...',
        staff: 'Staff',
        addWorkType: 'Add work type',
        workType: 'work type',
        shareWorkTime: 'Share of working time',
        costOfWorks: 'Cost of work',
        createVacancyFewDay: 'Create a vacancy for a few days',
        createFewDay: 'Create for a few days',
        selectDaysOfWeek: 'Select days of the week',
        dayOfWeek: 'day of week',
        dayOfWeekError: 'Select the day of the week',
        workerDayWeek: [{
          label: 'Mon',
          value: '0'
        }, {
          label: 'Tue',
          value: '1'
        }, {
          label: 'Wed',
          value: '2'
        }, {
          label: 'Thu',
          value: '3'
        }, {
          label: 'Fri',
          value: '4'
        }, {
          label: 'Sat',
          value: '5'
        }, {
          label: 'Sun',
          value: '6'
        }],
        workHoursQty: 'hours quantity',
        additionShiftShort: 'Add',
        additionShift: 'Addition shift',
        rules: {
          number: 'Enter the number',
          required: 'The field is required',
          positive: 'Must be a positive number',
          less24hours: 'Must not exceed 24 hours'
        }
      },
      acceptPlanOrFactModal: {
        ok: 'Confirm',
        approveOpenVacs: 'Confirm open shifts',
        planTitle: 'Confirmation of the planned schedule',
        factTitle: 'Confirmation of the fact schedule',
        requestTitle: 'Send a request to confirm the schedule',
        planError: 'An error occurred while confirming the planned schedule',
        factError: 'An error occurred while confirming the fact schedule',
        planAccepted: 'The planned schedule confirmed successfully',
        factAccepted: 'The fact schedule confirmed successfully',
        requestAccepted: 'Schedule confirmation request was successful',
        dateError: 'The end date of the period cannot be earlier than the start date',
        requestError: 'An error occurred when requesting to confirm the schedule',
        request: 'Send request',
        comment: 'Comment',
        graphics: 'Select the type of graph'
      },
      uploadScheduleModal: {
        scheduleTitle: 'Loading the schedule',
        uploadSuccess: 'Data loaded successfully',
        downloadTemplate: 'Download template',
        downloadDescription: 'Download description',
        fileLargeError: 'This file is too large',
        uploadErrorWrongData: 'Invalid data in uploaded file',
        selectPlanDays: 'Plan',
        downloadExampleFileTitle: 'Download Template',
        selectFactDays: 'Fact'
      },
      downloadModal: {
        scheduleTitle: 'Download "Shift Schedule"',
        tabletTitle: 'Download "Tabel"',
        needTitle: 'Download "The need for staff"',
        consolidatedTitle: 'Download "Consolidated report on time worked"',
        tickTitle: 'Download "Tick report"',
        scheduleDeviationTitle: 'Download "Schedule deviation report"',
        scheduleDeviationTypesOptions: {
          all: 'All',
          onlyVacancies: 'Only vacancies',
          onlyStoreShifts: 'Only store shifts',
          outsource: 'Outsource',
          notOutsource: 'Not outsource'
        },
        scheduleDeviationDisplayByTypes: 'Display by types',
        selectWorkType: 'Select work type',
        selectedWorkTypes: 'Selected work types',
        selectOutsource: 'Select outsource',
        selectedOutsourcings: 'Selected outsourcings',
        selectAll: 'Select all',
        datesInOneMonth: 'Time period must be within one month',
        tickCheckboxBiometrics: 'With biometric photos',
        buttonDownloadTitle: 'Download',
        incorrectEmail: 'Incorrect email',
        buttonEmailTitle: 'Send',
        emailWillBeSent: 'Report will be sent to specified email',
        dateMoreThanError: 'Please select a period of no more than 90 days',
        checkboxVersionTitle: 'Version for signature',
        selectDaysShorterMonth: 'Please select a period of no more than 31 days'
      },
      tabledays: {
        copy: 'Cells copied',
        successCopy: 'Copying was successful',
        errorCopy: 'An error occurred while copying',
        continue: 'Are you sure you want to continue?',
        needSelect: 'You must select the days to exchange',
        onlyApprAndNotAppr: 'Only notapproved or approved days are allowed',
        invalidDays: 'Invalid days selected',
        shiftEcxchange: 'Shift exchange completed successfully',
        createdBy: 'Created by',
        editedBy: 'Edited by',
        date: 'Date',
        comment: 'Comment',
        tasks: 'Tasks',
        allowedInterval: 'Acceptable tardiness/early leave interval',
        noData: 'No data',
        tardinessAndEarlyLeave: 'Tardiness/early leave',
        unplannedAttendance: 'Unplanned attendance',
        unapprovedChanges: 'Unapproved changes',
        inconsistencyOfShops: 'Inconsistency of shops',
        inconsistencyOfWorkType: 'Inconsistency in types of work',
        inconsistencyOfDayType: 'Inconsistency in day type',
        additionalShiftMismatch: 'Inconsistency in day being main/additional',
        unaccountedOvertime: 'There are unaccounted processing',
        noDataInDraft: 'No data in draft',
        marks: 'Marks',
        shift: {
          plural_1: 'Shifts',
          plural_2: 'Shifts'
        },
        warning: 'Warning',
        lock: 'Locked',
        notAvailable: 'Unavailable',
        employmentIs: "Employed in {shopName}",
        haveNotEmployments: 'The employee is not employed',
        noAnyData: 'No data'
      },
      tableTabel: {
        fact: 'Fact.',
        main: 'Main',
        additional: 'Addit.',
        details: 'details',
        dayShiftHours: 'hrs Day-shift:',
        nightShiftHours: 'hrs Night-shift:',
        timeOfWork: 'time of work',
        breakTime: 'break time',
        numberOfHours: 'number of hours:',
        hour: 'h',
        minute: 'm',
        workTime: 'working time:',
        schoolTime: 'school time:',
        tripTime: 'business trip time:',
        shift: {
          plural_1: 'Shifts',
          plural_2: 'Shifts'
        }
      },
      recalcTimesheetOrWorking: {
        ok: 'Confirm',
        timesheetRecalc: 'Recalculation of the timesheet for the month',
        workingRecalc: 'Recalculation of working hours',
        timesheetError: 'An error occurred while calculating the timesheet',
        workingError: 'An error occurred while calculating business hours',
        workingErrorDate: 'The end date of the period cannot be earlier than the start date',
        timesheetSuccess: 'Monthly timesheet calculation completed successfully',
        workingSuccess: 'Working hours calculation completed successfully'
      },
      consolidatedReportModal: {
        options: [{
          label: 'Employee + position',
          value: 'employee_position'
        }, {
          label: 'Position',
          value: 'position'
        }],
        selectLabel: 'Slice on'
      }
    },
    exchange: {
      vacancy: 'Vacancy',
      noOneVacancy: 'Sorry, there are no vacancies that match your criteria.',
      inShop: 'in the shop',
      replyLabel: 'Reply',
      approveLabel: 'Approve',
      comes: 'Comes',
      work: 'work',
      outsourcingCompany: 'Outsourcing company',
      refuseTitle: 'Refuse the vacancy',
      reconfirmTitle: 'Reconfirm the vacancy',
      deleteModal: {
        question: 'Are you sure you want to delete the vacancy?',
        answerPositive: 'Vacancy deleted successfully',
        answerNegative: 'Failed to delete vacancy'
      },
      confirmModal: {
        question: 'Are you sure you want to apply for this vacancy?',
        answerPositive: 'You have successfully applied for a vacancy',
        answerNegative: 'Failed to apply for vacancy'
      },
      reconfirmModal: {
        question: 'Are you sure you want to reassign the employee?',
        answerPositive: 'You have successfully reassigned an employee',
        answerNegative: 'Failed to reassign employee'
      },
      approveModal: {
        question: 'Are you sure you want to confirm this vacancy?',
        answerPositive: 'You have successfully confirmed the vacancy',
        answerNegative: 'Failed to confirm vacancy'
      },
      refuseModal: {
        question: 'Are you sure you want to refuse this vacancy?',
        answerPositive: 'You have successfully refused the vacancy',
        answerNegative: 'Failed to refuse vacancy'
      }
    },
    settings: {
      name: 'Name',
      title: 'Title',
      department: 'Department',
      key: 'Key',
      address: 'Address',
      city: 'City',
      parent: 'Parent subdivision',
      template: 'Template',
      status: 'Status',
      loadTemplate: 'Load template',
      settings: 'Shift template',
      timezone: 'Time zone',
      code: 'Code',
      missing: 'Missing',
      noData: 'no data to display',
      minShiftLength: 'Minimum length of shifts, h',
      maxShiftLength: 'Maximum length of shifts, h',
      maxNumberWorkingHours: 'Maximum number of working hours in a row',
      permissibleDowntime: 'Permissible downtime',
      minTimeBetweenShifts: 'Minimum time between shifts, h',
      depName: 'Department name',
      forecastStep: 'Forecast step, h.:min.',
      inputLabelTimezone: 'Timezone',
      area: 'Area',
      region: 'Region',
      workTime: 'Work time by days of the week',
      workTypes: 'Work types',
      minNumberEmpl: 'Min number of employees',
      maxNumberEmpl: 'Max number of employees',
      fieldsNotFilledCorrectly: 'Not all fields are filled in correctly',
      failedToSave: 'Failed to save store settings',
      savedSuccessfully: 'Store settings saved successfully',
      sameWorkingTime: 'same working time all days',
      depsFilter: 'Departments filter',
      positionsFilter: 'Positions filter',
      accessGroupsFilter: 'Access groups filter',
      businessDriversFilter: 'Business drivers filter',
      operationsFilter: 'Operations filter',
      workTypesFilter: 'Work types filter',
      loadTemplatesFilter: 'Load templates filter',
      timetableTemplatesFilter: 'Timetable templates filter',
      tickpointsFilter: 'Tickpoints filter',
      staffFilter: 'Staff filter',
      enterTheTitle: 'Enter the title',
      enterTheCode: 'Enter the code',
      enterLastname: 'Enter last name',
      enterLogin: 'Enter the login',
      listOfGroups: 'List of groups',
      selectDep: 'Select department',
      selectAll: 'Select all',
      selectAllGroups: 'Select groups',
      selectedGroupCount: 'Selected group count',
      selectAllWorkTypes: 'Select job types',
      selectWorkTypesCount: 'Selected types of work',
      tickpoint: {
        deleteConfirmTitle: 'Delete confirmation',
        deleteConfirm: 'Are you sure you want to delete this tickpoint?',
        saveSuccess: 'Tickpoint saved successfully',
        deleteSuccess: 'Tickpoint deleted successfully',
        deleteError: 'Failed operation delete'
      },
      latitude: 'Latitude',
      longitude: 'Longitude',
      loadTemplates: {
        addDependency: 'Add dependency',
        addOperation: 'Add operation',
        download: 'Download',
        dependency: 'Dependency',
        formula: 'Formula',
        unknownOperation: 'Unknown operation',
        applySuccess: 'Successfully applied',
        applyError: 'An error occurred',
        result: 'Result'
      },
      accessGroup: 'Employee access group',
      wTypesSavedSuccess: 'Work types saved successfully',
      wTypesSavedError: 'Failed to save work types'
    },
    staff: {
      currentEmployment: 'Current employment',
      downloadModal: {
        attendanceRecordsTitle: 'Download "Attendance records report"',
        reportReworkAndFlawTitle: 'Download overhaul / flaw report',
        buttonTitle: 'Download'
      },
      photo: 'Photo',
      fullname: 'Full name',
      username: 'Username',
      email: 'Email',
      phoneNumber: 'Phone number',
      position_title: 'Position title',
      dep_title: 'Departments',
      work_types_by_id: 'Work types',
      fromWebCam: 'From web cam',
      shoot: 'Take a shoot',
      reShoot: 'Reshoot',
      send: 'Send'
    },
    coverageCharts: {
      coverageSchedule: 'Coverage schedule by type of work',
      all: 'All',
      howMuchNeed: 'How much need',
      howMuchComesOut: 'How much comes out'
    },
    forecast: {
      businessDrivers: 'Business drivers',
      operations: 'Operations',
      workTypes: 'Work types',
      additionalFeatures: 'Additional features',
      uploadWorkloadModal: {
        workloadTitle: 'Loading load',
        uploadSuccess: 'Data loaded successfully',
        downloadTemplate: 'Download template',
        downloadDescription: 'Download description',
        fileLargeError: 'This file is too large',
        uploadErrorWrongData: 'Invalid data in uploaded file',
        uploadErrorsWarning: 'Errors during upload',
        selectPlanDays: 'Plan',
        downloadExampleFileTitle: 'Download Template',
        selectFactDays: 'Fact'
      }
    }
  },
  modals: {
    departments: {
      title: 'Select store',
      okButton: 'Save changes',
      filterPlaceholder: 'Filter by store name',
      depsLengthError: 'Please select at least one store',
      toggleButton: 'With a choice of children'
    },
    staffFilter: {
      filterTable: 'Filter table',
      selectedEmployees: 'Selected employees',
      selectedWorkTypes: 'Selected work types',
      selectedWorkerTypes: 'Selected employee types',
      selectEmployees: 'Select employees',
      selectWorkTypes: 'Select work type',
      selectWorkerTypes: 'Select employee type',
      selectAll: 'Select all',
      selectAllUsers: 'Select all',
      workerTypeOptions: [{
        label: 'Shop employee',
        value: EMPLOYEE_EMPLOYMENT_STATUSES
      }, {
        label: 'Internal',
        value: INTERNAL_EMPLOYMENT_STATUSES
      }, {
        label: 'Outsource',
        value: OUTSOURCE_EMPLOYMENT_STATUSES
      }]
    },
    staffAdd: {
      title: 'Adding employee',
      fullname: 'Full name',
      addBtnLabel: 'Add',
      dateHired: 'date of receipt',
      email: 'email',
      phoneNumber: 'phone',
      addWorker: '+ add worker',
      addWorkerSuccess: 'Worker added successfully',
      saveEmploymentsSuccess: 'Employee job placements saved successfully'
    },
    workerDetails: {
      menu: [{
        label: 'Info',
        icon: 'info',
        link: 'Info'
      }, {
        label: 'Employments',
        icon: 'device_hub',
        link: 'Employments'
      }, {
        label: 'Shift schedule',
        icon: 'today',
        link: 'ShiftSchedule',
        options: {
          show_employee_shift_schedule_tab: true
        }
      }, {
        label: 'Security',
        icon: 'security',
        link: 'Security'
      }, {
        label: 'Medical documents',
        icon: 'medical_services',
        link: 'Medical'
      }]
    },
    departmentSettings: {
      createTitle: 'Create department',
      editTitle: 'Department settings',
      commonSettings: 'Common settings',
      schedule: 'Schedule',
      cellSavedSuccess: 'Schedule saved successfully',
      cellSavedError: 'Failed to save schedule',
      autoscheduling: 'Autoscheduling',
      calculationOfTheNeed: 'Calculation of the need',
      ipAddresses: 'IP Addresses',
      confirmIpDelete: 'Are you sure you want to delete this IP address?',
      newIpAddress: 'New IP address',
      invalidIpAddress: 'Invalid IP address format'
    },
    operation: {
      constValue: 'Constant value',
      newOperation: 'New operation',
      operation: '* operation',
      timeDuration: 'Lead time',
      forecastStep: '* forecast step',
      depends: 'Depends on',
      noDepends: 'Has no dependencies',
      add: 'Add',
      formula: 'Formula',
      subNewOperation: '* new operation',
      deleteConfirmTitle: 'Delete confirmation',
      operationDeleteConfirm: 'Are you sure you want to delete this operation?',
      operationSaveSuccess: 'Operation saved successfully',
      operationDeleteSuccess: 'Operation deleted successfully',
      operationDeleteError: 'Failed operation delete',
      dependenceDeleteSuccess: 'Dependence deleted successfully',
      validError: 'Not all fields are filled in correctly',
      operationLabel: 'Operation',
      dtFromLabel: 'Start time',
      dtToLabel: 'End time',
      forecastStepLabel: 'Forecast step',
      constValueLabel: 'Constant value',
      min_30: '30 min',
      hour_1: '1 h',
      day_1: '1 d'
    },
    deleteSchedule: {
      modalTitle: 'Deleting schedule',
      selectAll: 'Select all',
      deletePeriod: 'Period for deletion',
      selectPlanDays: 'Plan',
      selectFactDays: 'Fact',
      daysWithinNotFound: 'No matching days found',
      selectWorkers: 'Select workers',
      selectDates: 'Select dates',
      deletedSuccess: 'Deleted successfully',
      excludeCreatedBy: "Don't delete manual changes",
      excludeCreatedByOtherDepartment: 'Don\'t delete working days in other departments',
      searchWorkers: 'Search'
    },
    duplicateSchedule: {
      modalTitle: 'Duplicate schedule',
      modalCopyMonthTitle: 'Copying from month to month',
      selectAll: 'Select all',
      copyPeriod: 'Period for duplicate',
      copyPeriodMonth: 'Copy period',
      pastePeriodMonth: 'Insert period',
      typeDay: 'Types of days',
      selectPlanDays: 'Plan',
      selectFactDays: 'Fact',
      selectWorkers: 'Select workers',
      selectDates: 'Select dates',
      selectWorkersDay: 'Select the type of day',
      copiedSuccess: 'Copied successfully',
      fromPlanToPlanDraft: 'From plan to plan draft',
      fromFactToFactDraft: 'From fact to fact draft',
      fromPlanToFactDraft: 'From plan to fact draft',
      searchWorkers: 'Search'
    },
    settings: {
      code: 'code',
      name: 'name',
      title: 'title',
      dep: 'department',
      key: 'key',
      operationName: 'operation name',
      availableFunctions: 'Available functions',
      positionName: 'position name',
      createPosition: 'Create position',
      updatePosition: 'Update position',
      createTickpoint: 'Create tickpoint',
      updateTickpoint: 'Create tickpoint',
      createAccessGroup: 'Create access group',
      updateAccessGroup: 'Update access group',
      createLoadTemplate: 'Create load template',
      updateLoadTemplate: 'Update load template',
      createTimetableTemplate: 'Create schedule template',
      updateTimetableTemplate: 'Update schedule template',
      createBlockWorkDays: 'Restriction on editing shifts',
      exit1day: 'A weekly break of 1 day off is acceptable',
      exit42hours: '42 hours week break',
      pairedWeekday: 'Mandatory paired weekends',
      businessDriver: 'business driver',
      operation: 'operation',
      workType: 'work type',
      create: 'Create',
      update: 'Update',
      toCreate: 'Create',
      toSave: 'Save',
      feedbackTitle: 'Feedback',
      searchShop: 'Store search',
      toggleButton: 'With a choice of children',
      block: 'Lifting the ban',
      successMessage: 'Changes applied successfully'
    },
    employment: {
      title: 'Employments',
      add: 'Add',
      department: 'Department',
      position: 'Position',
      tabelCode: 'Personnel Number',
      salary: 'The salary',
      startDate: 'start date',
      endDate: 'end date',
      shareOfWorkingHours: 'share of working hours',
      sawhSettings: 'Hours norm setting',
      fixedSchedule: 'fixed schedule',
      displayGraph: 'Whether to display in graphics',
      workType: 'Work type',
      availabilityType: 'Employee availability type',
      not: 'not',
      main: 'main',
      additional: 'addit.',
      weekly: 'Weekly',
      floating: 'Floating',
      periodDays: 'days in the period',
      startOfPeriodicity: 'start of periodicity',
      dayEditMode: 'Day edit mode',
      limitations: 'Limitations',
      wishes: 'Wishes',
      archive: 'Archive',
      newEmployment: 'New employment',
      noStartEndTimes: 'The store\'s opening hours are not set',
      group: 'Employee access group',
      noWorkTypes: 'There are no available work types',
      unknownDepartment: 'Unknown department',
      unknownPosition: 'Unknown position',
      unknownGroup: 'Unknown group',
      historyEmployments: 'History',
      futureEmployments: 'Future',
      allEmployments: 'All'
    },
    reports: {
      title: 'Charts filter',
      selectAll: 'Select all',
      selectAllEmployees: 'Select all',
      selectEmployees: 'Select employees',
      selectedEmployees: 'Selected employees',
      displayByTypes: 'Display by types',
      all: 'All',
      onlyVacancies: 'Only vacancies',
      onlyStoreShifts: 'Only store shifts',
      outsource: 'Outsource',
      notOutsource: 'Not outsource',
      selectWorkType: 'Select work type',
      selectedWorkTypes: 'Selected work types',
      selectOutsource: 'Select outsource',
      selectedOutsourcings: 'Selected outsourcings',
      modalPivotTabelTitle: 'Download summary sheet',
      download: 'Download'
    },
    tickpoint: {
      deleteConfirmTitle: 'Delete confirmation',
      deleteConfirm: 'Are you sure you want to delete this tickpoint?',
      saveSuccess: 'Tickpoint saved successfully',
      deleteSuccess: 'Tickpoint deleted successfully',
      deleteError: 'Failed operation delete'
    },
    exchange: {
      title: 'Select outsourcing chain',
      okButton: 'Save changes',
      filterPlaceholder: 'Filter by store name',
      depsLengthError: 'Please select at least one chain',
      toggleButton: 'With a choice of children'
    },
    autoschedulingSettings: {
      title: 'Autoscheduling settings',
      shiftpattern: 'shift pattern',
      compilationRules: 'Compilation rules',
      invalidStartTime: 'Invalid shift start time',
      invalidEndTime: 'Invalid shift end time',
      savedSuccess: 'Autoscheduling settings saved successfully',
      savedError: 'Failed to save autoscheduling settings'
    },
    calculationOfTheNeed: {
      loadTemplates: 'load templates',
      savedSuccess: 'Saved successfully',
      savedError: 'Failed to save'
    },
    shiftSchedule: {
      title: 'Shift schedule',
      total: 'Total:'
    },
    medical: {
      title: 'Medical documents',
      addBtnTitle: 'Add document',
      selectDocumentTitle: 'Select document',
      dateFromTitle: 'Relevant from (date)',
      dateToTitle: 'Relevant until (date)',
      successSave: 'Medical documents saved',
      errorSave: 'Error saving medical documents'
    }
  },
  dateTimeSettings: {
    dateMask: 'YYYY/MM/DD',
    timeMask: 'HH:mm',
    dayMonthDateMask: 'MM/DD',
    daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    firstDayOfWeek: '0',
    hoursSettings: ['hours', 'hours', 'hours']
  },
  table: {
    selectedRows: 'Selected rows',
    visibleFields: 'Visible fields',
    selectAll: 'Select all',
    deselectAll: 'Remove all selection',
    enterValue: 'Enter a',
    templateOperation: {
      operation: 'Operation',
      startTime: 'Start time',
      endTime: 'End time',
      forecastStep: 'Forecast step',
      constValue: 'Constant value'
    },
    relations: {
      dependsOn: 'Depends on',
      formula: 'Formula'
    }
  },
  tabelTypes: {
    'F': 'Fact tabel',
    'M': 'Main tabel',
    'A': 'Additional tabel',
    'MA': 'Main/additional tabel'
  },
  errors: {
    status: {
      500: 'Please contact technical support.',
      502: 'Service temporarily unavailable. Please try again later.',
      504: 'Request timeout. Please try again later.'
    }
  }
};